export const sizes = {
    P: '(min-width: 768px)',
    M: '(min-width: 1024px)',
    G: '(min-width: 1200px)',
    XG: '(min-width: 1440px)',
    XXG: '(min-width: 1740px)',
};
